// extracted by mini-css-extract-plugin
export default {"signBlock":"log-in_signBlock__oKFJe","form":"log-in_form__PtVsq","title":"log-in_title__B16kU","submit":"log-in_submit__Ij7OE","question":"log-in_question__F6FKx"};